// extracted by mini-css-extract-plugin
export default {"container":"Social_container__MNazY"};